/**
 * The nine detail cases a work row can open, mirroring `App\Enums\HomeDetailType`.
 *
 * FINER THAN THE EIGHT SECTION TYPES, and only for one reason: the open-actions
 * section merges plan activities and project actions, which live in separate
 * tables with separate id sequences. A request naming only the section could
 * not say which table an id belongs to, so those two get a case each.
 *
 * THE CLIENT NEVER DERIVES THESE. Every row arrives with its own `detail_type`
 * and the pop-up echoes it straight back — these constants exist so the BODIES
 * registry can be keyed by something checkable, not so a row's type can be
 * inferred from its `source` label or the section it sits in.
 */
export const DETAIL_TYPE_PLAN_ACTIVITY = 'plan_activity';
export const DETAIL_TYPE_PROJECT_ACTION = 'project_action';
export const DETAIL_TYPE_RISKS = 'risks';
export const DETAIL_TYPE_ISSUES = 'issues';
export const DETAIL_TYPE_DECISIONS = 'decisions';
export const DETAIL_TYPE_OPPORTUNITIES = 'opportunities';
export const DETAIL_TYPE_PROCUREMENTS = 'procurements';
export const DETAIL_TYPE_CONTRACTS = 'contracts';
export const DETAIL_TYPE_EVALUATIONS = 'evaluations';
